export default {
  dusty: '#E6C3B4',
  dustyLight: '#F5E0D7',
  red: '#B8151B',
  dustyRed: '#AE4444',
  black: '#4A4647',
}
